import {
  Autocomplete,
  DrawingManager,
  GoogleMap,
  MarkerF,
} from "@react-google-maps/api";
import { useEffect, useState } from "react";
import { Button } from "@mui/material";
import RoomIcon from "@mui/icons-material/Room";
import EditLocationAltIcon from "@mui/icons-material/EditLocationAlt";
import WrongLocationIcon from "@mui/icons-material/WrongLocation";
import SaveIcon from "@mui/icons-material/Save";
import { useGoogleMaps } from "../../../../../utils/mapConfig";
import { Col, Row } from "react-bootstrap";
import "./businessLocation.css";

const BusinessLocation = ({
  businessLocation,
  editable,
  onEditToggle,
  setBusinessPoints,
  selected,
  setSelected,
  isFullScreen
}) => {
  const [center, setCenter] = useState({ lat: 0, lng: 0 });
  const [currentLocation, setCurrentLocation] = useState(null);
  const [drawingMode, setDrawingMode] = useState(null);
  const [autocomplete, setAutocomplete] = useState(null);
  const [initialLocation, setInitialLocation] = useState(null);
  const [hasEdited, setHasEdited] = useState(false);

  const { isLoaded } = useGoogleMaps();

  useEffect(() => {
    if (
      businessLocation &&
      typeof businessLocation.latitude === "number" &&
      typeof businessLocation.longitude === "number"
    ) {
      setCenter({
        lat: businessLocation.latitude,
        lng: businessLocation.longitude,
      });
    } else if (!initialLocation && currentLocation) {
      setCenter(currentLocation);
      setInitialLocation(currentLocation);
    }
  }, [businessLocation, currentLocation, initialLocation]);

  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          const location = { lat: latitude, lng: longitude };
          setCurrentLocation(location);
          if (!initialLocation) {
            setCenter(location);
            setInitialLocation(location);
          }
        },
        (error) => {
          console.error("Error fetching current location:", error);
        }
      );
    } else {
      console.error("Geolocation is not supported by this browser.");
    }
  }, [initialLocation]);

  useEffect(() => {
    let originalParent;

    const handleFullscreenChange = (event) => {
      const target = event.target;
      const mapControls = document.querySelector(".map-controls-inside-map");

      if (mapControls) {
        if (document.fullscreenElement === target) {
          originalParent = mapControls.parentElement;
          if (selected === 2) {
            target.appendChild(mapControls);
          }
        } else if (originalParent) {
          originalParent.appendChild(mapControls);
        }
      }
    };

    document.addEventListener("fullscreenchange", handleFullscreenChange);

    return () => {
      document.removeEventListener("fullscreenchange", handleFullscreenChange);
    };
  }, [selected]);

  const handleMapClick = (e) => {
    if (!editable) return;

    const newLat = e.latLng?.lat();
    const newLng = e.latLng?.lng();

    if (typeof newLat === "number" && typeof newLng === "number") {
      setCenter({ lat: newLat, lng: newLng });
      setHasEdited(true);
    }
  };

  const handleDrawToggle = () => {
    setDrawingMode(drawingMode === "marker" ? null : "marker");
  };

  const handleSubmit = () => {
    if (center) {
      setBusinessPoints(center);
      onEditToggle();
      setHasEdited(false);
    }
  };

  const handleClear = () => {
    setCenter(currentLocation);
    setHasEdited(true);
  };

  const handleMarkerComplete = (marker) => {
    const position = marker.getPosition();
    if (position) {
      setCenter({
        lat: position.lat(),
        lng: position.lng(),
      });
      setHasEdited(true);
      marker.setMap(null);
    }
  };

  const handlePlaceChanged = () => {
    if (autocomplete !== null) {
      const place = autocomplete.getPlace();
      if (place.geometry && place.geometry.location) {
        const lat = place.geometry.location.lat();
        const lng = place.geometry.location.lng();
        setCenter({ lat, lng });
        setHasEdited(true);
      }
    }
  };

  const options = {
    streetViewControl: false,
    fullscreenControl: false,
  };

  return isLoaded ? (
    <div
      onClick={() => {
        setSelected(2);
      }}
    >
      <GoogleMap
          mapContainerClassName={`appmap ${isFullScreen ? "fullscreen" : ""}`}
        center={center}
        zoom={12}
        onClick={handleMapClick}
        options={options}
      >
        {/* <div className="map-controls-inside-map">
          <Row className="map-btn-controlss">
            <Col>
              <Autocomplete
                onLoad={(autocompleteInstance) =>
                  setAutocomplete(autocompleteInstance)
                }
                onPlaceChanged={handlePlaceChanged}
              >
                <input
                  type="text"
                  placeholder="Search location"
                  className="autocomplete-input"
                  style={{
                    width: "300px",
                    padding: "10px",
                    margin: "0 auto",
                    border: "1px solid #ccc",
                    borderRadius: "4px",
                    position: "relative",
                  }}
                />
              </Autocomplete>
            </Col>
            <Col>
              <div className="map-control-btnss">
                <Button
                  className="map-submit-btn"
                  variant="contained"
                  color="primary"
                  onClick={handleDrawToggle}
                >
                  {drawingMode ? "Back" : <RoomIcon />}
                </Button>
                <Button
                  className="map-submit-btn"
                  variant="contained"
                  color="secondary"
                  onClick={() => {
                    onEditToggle();
                    if (drawingMode === "marker") {
                      handleDrawToggle();
                    }
                  }}
                >
                  {editable ? "Back" : <EditLocationAltIcon />}
                </Button>

                <Button
                  className="map-submit-btn"
                  variant="contained"
                  color="error"
                  onClick={handleClear}
                >
                  <WrongLocationIcon />
                </Button>
                <Button
                  className="map-submit-btn"
                  variant="contained"
                  color="success"
                  onClick={handleSubmit}
                  disabled={!hasEdited}
                >
                  <SaveIcon />
                </Button>
              </div>
            </Col>
          </Row>
        </div> */}
        {drawingMode === "marker" && (
          <DrawingManager
            options={{
              drawingControl: true,
              drawingControlOptions: {
                position: window.google.maps.ControlPosition.TOP_RIGHT,
                drawingModes: ["marker"],
              },
            }}
            onMarkerComplete={handleMarkerComplete}
          />
        )}
        {center && <MarkerF position={center} />}
      </GoogleMap>
    </div>
  ) : (
    <div>Loading Map...</div>
  );
};

export default BusinessLocation;
